import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} WarehouseAddress
 * @property {string} id
 * @property {string} address_1
 * @property {string} address_2
 * @property {string} city
 * @property {string} state
 * @property {string} zip
 * @property {string} country
 * @property {string} phone
 * @property {string} email
 * @property {boolean} is_primary
 */

/**
 * @typedef {Object} Warehouse
 * @property {string} id
 * @property {string} name
 * @property {string} warehouse_type
 * @property {boolean} is_active
 * @property {WarehouseAddress[]} addresses
 */

/**
 * @typedef {Object} WarehousesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, Warehouse>} data
 */

export const WAREHOUSES_ACTIONS = {
  SET_WAREHOUSES: 'SET_WAREHOUSES',
  SET_WAREHOUSE: 'SET_WAREHOUSE',
  SET_STATUS: 'SET_WAREHOUSES_STATUS',
  SET_ERRORS: 'SET_WAREHOUSES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_WAREHOUSES_ERRORS'
}

export const initialWarehousesState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const warehousesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      warehouse_type: PropTypes.string,
      is_active: PropTypes.bool,
      addresses: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          address_1: PropTypes.string,
          address_2: PropTypes.string,
          city: PropTypes.string,
          state: PropTypes.string,
          zip: PropTypes.string,
          country: PropTypes.string,
          phone: PropTypes.string,
          email: PropTypes.string,
          is_primary: PropTypes.bool
        })
      )
    })
  )
}
